import { render, staticRenderFns } from "./GroupsSelectorModal.vue?vue&type=template&id=ec512892&"
import script from "./GroupsSelectorModal.vue?vue&type=script&lang=ts&"
export * from "./GroupsSelectorModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports